window.deleteEvent = function (event_id) {
    swal("¿Está seguro que desea eliminar el evento?", {
        buttons: {
            cancel: "Cancelar",
            eliminar: true,
        },
        icon: "warning",
    })
        .then((value) => {
            if (value) {
                Livewire.emit('deleteEvent', event_id);
            }
        });
}

window.deleteCard = function (card_id) {
    swal("¿Está seguro que desea eliminar la tarjeta?", {
        buttons: {
            cancel: "Cancelar",
            eliminar: true,
        },
        icon: "warning",
    })
        .then((value) => {
            if (value) {
                Livewire.emit('deleteCard', card_id);
            }
        });
}

window.showPreview = function (id) {
    let addon = '';
    if (id) {
        addon = '-' + id;
    }
    if (event.target.files.length > 0) {
        let src = URL.createObjectURL(event.target.files[0]);
        let preview = document.getElementById('photo-preview' + addon);
        let button = document.getElementById('eliminate-button' + addon);
        let label = document.getElementById('photo-label' + addon);
        preview.src = src;
        label.classList.add('d-none');
        button.classList.remove('d-none');
    }
}

window.removeImage = function (id) {
    let addon = '';
    if (id) {
        addon = '-' + id;
    }
    let preview = document.getElementById('photo-preview' + addon);
    let button = document.getElementById('eliminate-button' + addon);
    let label = document.getElementById('photo-label' + addon);
    let photo = document.getElementById('photo' + addon);
    let selected = document.getElementById('type' + addon);
    if (selected) {
        selected = selected.options[selected.selectedIndex].value
        preview.src = getImage(selected);
    } else {
        if (check_support_for_webp()) {
            preview.src = '//' + window.location.hostname + '/images/events/Otro.webp';
        } else {
            preview.src = '//' + window.location.hostname + '/images/events/Otro.jpg';
        }
    }
    photo.value = null;
    button.classList.add('d-none');
    label.classList.remove('d-none');
}

function check_support_for_webp() {
    var elem = document.createElement('canvas');

    if (!!(elem.getContext && elem.getContext('2d'))) {
        // was able or not to get WebP representation
        return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    } else {
        // very old browser like IE 8, canvas not supported
        return false;
    }
}

window.getImage = function (selected) {
    let image = '';
    switch (selected) {
        case '1':
            image = '//' + window.location.hostname + '/images/events/Boda.';
            break;
        case '2':
            image = '//' + window.location.hostname + '/images/events/Cumpleaños.';
            break;
        case '3':
            image = '//' + window.location.hostname + '/images/events/Nacimiento.';
            break;
        case '4':
            image = '//' + window.location.hostname + '/images/events/Shower.';
            break;
        case '5':
            image = '//' + window.location.hostname + '/images/events/Graduación.';
            break;
        default:
            image = '//' + window.location.hostname + '/images/events/Otro.';
            break;
    }
    if (check_support_for_webp()) {
        image = image + 'webp';
    } else {
        image = image + 'jpg';
    }
    return image;
}

window.changeEvent = function (id) {
    let addon = '';
    if (id) {
        addon = '-' + id;
    }
    let image = document.getElementById('photo' + addon).value;
    if (image === null || image === '') {
        let value = document.getElementById('type' + addon).value;
        document.getElementById('photo-preview' + addon).src = getImage(value);
    }
}

window.loadEvents = function () {
    $('.date-picker').flatpickr({
        altInput: true,
    });
}

window.addCard = function () {
    $('#newCard').modal('show')
}

window.share = function (element) {
    let id = element.getAttribute('data-id');
    let name = element.getAttribute('data-name');
    let type = element.getAttribute('data-type');

    if (navigator.share) {
        navigator.share({
            title: 'Lazo',
            text: name,
            url: '/' + type + '/' + id,
        })
            .error((error) => {
                swal("Lo sentimos hubo un error.")
            });
    } else {
        const el = document.createElement('textarea');
        el.value = name + '\r\n https://www.lazopanama.com/' + type + '/' + id;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        $('#' + id).tooltip('show');
        setTimeout(function () {
            $('#' + id).tooltip('hide');
        }, 1000);
    }
}
